import { Box, InputAdornment, TextField } from "@mui/material"
import { FilterAltOutlined, SearchOutlined } from "@mui-symbols-material/w300"
import { useNavigate } from "@tanstack/react-router"
import type { ChangeEvent, ReactNode } from "react"

import { useCompanyEditSearch } from "../hooks"

import { Button } from "@/components/common/Button"
import { getRefinedSearchParams } from "@/utils/getRefinedSearchParams"

interface ProductSearchBarProps {
  onShowFilter: () => void
}

export const ProductSearchBar = ({ onShowFilter }: ProductSearchBarProps): ReactNode => {
  const currentSearch = useCompanyEditSearch()
  const navigate = useNavigate()
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const queryValue = e.target.value

    const updatedSearchParams = getRefinedSearchParams({
      ...currentSearch,
      query: queryValue,
    })

    void navigate({
      to: "/app/companies/$companyId/edit/products",
      search: updatedSearchParams.search,
    })
  }

  return (
    <Box className='flex w-full items-center space-x-4'>
      <TextField
        data-testid='search-input'
        defaultValue={currentSearch?.query}
        variant='outlined'
        placeholder='Search by Product Name or ID'
        className='w-full max-w-lg'
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position='start'>
                <SearchOutlined className='text-gray-600' />
              </InputAdornment>
            ),
          },
        }}
        onChange={handleInputChange}
      />
      <Button aria-label='filter' appearance='outlined' onClick={onShowFilter} startIcon={<FilterAltOutlined />}>
        Filter
      </Button>
    </Box>
  )
}
